import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/// If it has an isoString, it'll return it with the selected timezone,
/// if timezone is undefined it'll be set as Rome by default, 'cause why not
export const convertUtcToTzIsoDayJs = (isoString: string | null | undefined, tz: string = "Europe/Rome"): dayjs.Dayjs | null => {
    if (!isoString) return null;

    // Convert UTC to target timezone
    const inDmsTz = dayjs.utc(isoString).tz(tz);

    // Recreate a "local" datetime keeping Y/M/D/H/M/S, without timezone
    return dayjs()
        .year(inDmsTz.year())
        .month(inDmsTz.month())
        .date(inDmsTz.date())
        .hour(inDmsTz.hour())
        .minute(inDmsTz.minute())
        .second(inDmsTz.second())
        .millisecond(inDmsTz.millisecond())
};

export const revertUtcToTzIsoDayJs = (isoString: string | null | undefined, tz: string = "Europe/Rome"): dayjs.Dayjs | null => {
    if (!isoString) return null;

    // const diff = dayjs(isoString) - convertUtcToTzIsoDayJs(isoString, tz);
    // return dayjs(isoString) + diff;

    const original = dayjs(isoString);
    const converted = convertUtcToTzIsoDayJs(isoString, tz);

    // Difference in milliseconds
    const diff = original.diff(converted);

    return original.add(diff, "millisecond");
};


// Converte stringa ISO UTC in una stringa che il TimePicker mostrerà come orario del DMS
// creiamo una data "locale" con l'ora del DMS, così il TimePicker la mostra correttamente
export const convertUtcToTzIsoStringWithFormat = (isoString: string | null | undefined, tz: string, format: string): string | null => {
    if (!isoString) return null;

    return convertUtcToTzIsoDayJs(isoString, tz)?.format(format) ?? null;
};

// Converte stringa ISO UTC in una stringa che il TimePicker mostrerà come orario del DMS
// creiamo una data "locale" con l'ora del DMS, così il TimePicker la mostra correttamente
export const convertUtcToTzIsoString = (isoString: string | null | undefined, tz: string): string | null => {
    if (!isoString) return null;

    return convertUtcToTzIsoDayJs(isoString, tz)?.format() ?? null;
};

// Converte l'orario "visivo", che l'utente vede come orario del DMS, in UTC per il backend
// L'utente imposta 08:00 pensando sia l'orario di Lisbona, dobbiamo salvare 08:00 UTC (se Lisbona = UTC)
export const convertVisualTimeToUtc = (value: any, dmsTimezone: string): string | null => {
    if (!value) return null;
    const d = dayjs.isDayjs(value) ? value : dayjs(value);
    if (!d.isValid()) return null;
    // Estrai l'ora "visiva" (quella che l'utente vede)
    const hour = d.hour();
    const minute = d.minute();
    const second = d.second();
    // Crea una data nel timezone del DMS con quell'ora, poi convertila in UTC
    const inDmsTz = dayjs.tz(`2026-01-19T${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`, dmsTimezone);
    return inDmsTz.utc().format();
};

export const convertLocalToTzIso = (localDateString: string, tz: string): string => {
    const localDate = dayjs(localDateString);

    const tzDate = dayjs.tz(
        `${localDate.year()}-${String(localDate.month() + 1).padStart(2, '0')}-${String(localDate.date()).padStart(2, '0')} ${String(localDate.hour()).padStart(2, '0')}:${String(localDate.minute()).padStart(2, '0')}:${String(localDate.second()).padStart(2, '0')}`,
        tz
    );

    return tzDate.toISOString();
};
